export const expertsArray = [
  {
    expertId: "expert18_avani",
    name: "Avani",
    position: "Clinical Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/service-page/avani-clinical-psychologist",
  },
  {
    expertId: "expert22_ananda",
    name: "Ananda",
    position: "Rehab. Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/service-page/ananda-rehab-psychologist",
  },
  {
    expertId: "expert36_ankita",
    name: "Ankita",
    position: "Clinical Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/service-page/ankita-joshi-clinical-psychologist",
  },
  {
    expertId: "expert26_anoushka",
    name: "Anoushka",
    position: "Counseling Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/service-page/anoushka-raut-counseling-psychologist",
  },
  {
    expertId: "expert2_anupama",
    name: "Anupama",
    position: "Sr. Counseling Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/service-page/anupama-sr-counseling-psychologist",
  },
  {
    expertId: "expert21_krishna",
    name: "Krishna ",
    position: "Clinical Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/service-page/krishna-clinical-psychologist",
  },
  {
    expertId: "expert31_kaynaat",
    name: "Kaynaat ",
    position: "Counseling Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/service-page/kaynaat-iqbal-counseling-psychologist",
  },
  {
    expertId: "expert31_kaynaat",
    name: "Kaynaat ",
    position: "Counseling Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/service-page/kaynaat-iqbal-counseling-psychologist",
  },
  {
    expertId: "expert32_kruttikka",
    name: "Kruttikka ",
    position: "Counseling Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/service-page/kruttikka-s-counseling-psychologist",
  },
  {
    expertId: "expert44_kashika",
    name: "Kashika  ",
    position: "Counseling Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/booking-calendar/kashika-gulati-counseling-psychologist",
  },
  {
    expertId: "expert25_khushboo",
    name: "Khushboo",
    position: "Counseling Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/service-page/khushboo-mehta-counseling-psychologist",
  },
  {
    expertId: "expert23_mansoor",
    name: "Mansoor",
    position: "Clinical Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/service-page/mansoor-clinical-psychologist",
  },
  {
    expertId: "expert24_mansi",
    name: "Mansi",
    position: "Counseling Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/service-page/mansi-korde-counseling-psychologist",
  },
  {
    expertId: "expert3_meharmeet",
    name: "Meharmeet  ",
    position: "Counseling Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/service-page/meharmeet-counseling-psychologist",
  },
  {
    expertId: "expert9_mahi",
    name: "Mahi",
    position: "Counseling Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/service-page/mahi-modi-counseling-psychologist",
  },
  {
    expertId: "expert30_munira",
    name: "Munira ",
    position: "Counseling Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/service-page/munira-p-counseling-psychologist",
  },
  {
    expertId: "expert35_nidhi",
    name: "Nidhi ",
    position: "Clinical Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/service-page/nidhi-nahata-clinical-psychologist",
  },
  {
    expertId: "expert8_poojita",
    name: "Poojita  ",
    position: "Counseling Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/service-page/poojita-binu-counseling-psychologist",
  },
  {
    expertId: "expert27_preetha",
    name: "Preetha  ",
    position: "Counseling Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/service-page/preetha-sunil-counseling-psychologist",
    mobile: "9243201368",
  },
  {
    expertId: "expert41_rashi",
    name: "Rashi",
    position: "Counseling Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/service-page/rashi-goyal-counseling-psychologist-1",
  },
  {
    expertId: "expert58_divyakhanna",
    name: "Divya Khanna",
    position: "Counseling Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/service-page/divya-khanna-counseling-psychologist?referral=service_list_widget",
  },
  {
    expertId: "expert59_hansak",
    name: "Hansa K",
    position: "Counseling Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/service-page/dr-hansa-k-counseling-psychologist?referral=service_list_widget",
  },
  {
    expertId: "expert39_rachel",
    name: "Rachel",
    position: "Counseling Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/service-page/rachel-anne-d-counseling-psychologist",
    mobile: "8527762328",
  },
  {
    expertId: "expert56_hemanipanchal",
    name: "Hemani Panchal",
    position: "Counseling Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/service-page",
    mobile: "9998841777",
  },
  {
    expertId: "expert66_aanchallakhotia",
    name: "Aanchal Lakhotia",
    position: "Counseling Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/service-page",
    mobile: "6290803090",
  },
  {
    expertId: "expert57_swati",
    name: "Swati",
    position: "Counseling Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/service-page",
    mobile: "9717278300",
  },
  {
    expertId: "expert46_risha",
    name: "Risha",
    position: "Counseling Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/service-page/risha-b-counseling-psychologist",
  },
  {
    expertId: "expert15_sharmeen",
    name: "Sharmeen",
    position: "Counselor/Art Therapist",
    app_link: "",
    link: "https://www.manoshala.com/service-page/sharmeen-kaur-counselor-art-therapist",
  },
  {
    expertId: "expert28_sakina",
    name: "Sakina",
    position: "Counseling Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/service-page/sakina-p-counseling-psychologist",
  },
  {
    expertId: "expert34_shefali",
    name: "Shefali",
    position: "Counseling Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/service-page/shefali-b-counseling-psychologist",
    mobile: "9855988827",
  },
  {
    expertId: "expert38_sikha",
    name: "Shikha",
    position: "Counseling Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/service-page/shikha-jain-counseling-psychologist",
    mobile: "8758305030",
  },
  {
    expertId: "expert6_sonam",
    name: "Sonam",
    position: "Counseling Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/service-page/sonam-counseling-psychologist",
  },
  {
    expertId: "expert7_sanchari",
    name: "Sanchari",
    position: "Counseling Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/service-page/sanchari-nag-counseling-psychologist",
  },
  {
    expertId: "expert42_supriya",
    name: "Supriya",
    position: "Counseling Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/service-page/supriya-gupta-counseling-psychologist",
  },
  {
    expertId: "expert4_tamannarajpal",
    name: "Tamanna Rajpal",
    position: "Counseling Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/service-page/tamanna-r-counseling-psychologist",
    mobile: "9643067955",
  },
  {
    expertId: "expert_prakriti",
    name: "Prakriti",
    position: "Counseling Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/service-page/",
    mobile: "6396994399",
  },
  {
    expertId: "expert5_tamannagrewal",
    name: "Tamanna Grewal",
    position: "Counseling Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/service-page/tamanna-g-counseling-psychologist",
  },
  {
    expertId: "expert10_tanya",
    name: "Tanya",
    position: "Counseling Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/service-page/tanya-singh-counseling-psychologist",
  },
  {
    expertId: "expert37_yamini",
    name: "Yamini",
    position: "Counseling Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/service-page/yamini-punj-counseling-psychologist",
  },
  {
    expertId: "expert1_zoha",
    name: "Zoha",
    position: "Sr. Counseling Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/service-page/zoha-sr-counseling-psychologist",
  },
  {
    expertId: "expert60_anuradhakunte",
    name: "Anuradha Kunte",
    position: "Counseling Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/service-page/anuradha-kunte-counseling-psychologist?referral=service_list_widget",
  },
  {
    expertId: "expert61_sharongeorge",
    name: "Sharon George",
    position: "Counseling Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/service-page/sharon-george-counseling-psychologist",
  },
  {
    expertId: "expert62_divyanganay",
    name: "Divyangana Y",
    position: "Counseling Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/service-page/divyangana-yadav-clinical-psychologist",
  },
  {
    expertId: "expert29_khushbua",
    name: "Khushbua",
    position: "Counseling Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/service-page/khushbu-a-counseling-psychologist",
  },
  {
    expertId: "expert48_sonia",
    name: "Sonia",
    position: "Counseling Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/service-page/sonia-batra-counseling-psychologist",
    mobile: "9711039849",
  },
  {
    expertId: "expert33_dechen",
    name: "Dechen",
    position: "Clinical Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/service-page/dechen-sherpa-clinical-psychologist",
    mobile: "9958983089",
  },
  {
    expertId: "expert51_mudassir",
    name: "Mudassir M",
    position: "Counseling Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/service-page/mudassir-m-counseling-psychologist",
    mobile: "8247413161",
  },
  {
    expertId: "expert52_tanviarneja",
    name: "Tanvi Arneja",
    position: "Clinical Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/sessions",
    mobile: "9953008825",
  },
  {
    expertId: "expert53_sanjanabarot",
    name: "Sanjana Barot",
    position: "Consultant Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/service-page/sanjana-barot-consultant-psychologist",
    mobile: "9820248245",
  },
  {
    expertId: "expert54_gunjanjoshi",
    name: "Gunjan Joshi",
    position: "Clinical Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/service-page/gunjan-joshi-clinical-psychologist?referral=service_list_widget",
    mobile: "9044429962",
  },
  {
    expertId: "expert55_varunpreetsaini",
    name: "Varun Preet Saini",
    position: "Counselling Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/service-page/varun-preet-s-counseling-psychologist",
    mobile: "9044429962",
  },
  {
    expertId: "expert47_tanuushree",
    name: "Tanushree Sarawagi",
    position: "Senior Counselor",
    app_link: "",
    link: "https://www.manoshala.com/service-page/tanuushree-s-counseling-psychologist",
    mobile: "8279742869",
  },
  {
    expertId: "expert63_sumerasethi",
    name: "Sumera Sethi",
    position: "Counseling Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/service-page/sumera-sethi-counseling-psychologist",
    mobile: "9044429962",
  },
  {
    expertId: "expert64_hiteshkumar",
    name: "Hitesh Kumar",
    position: "Counseling Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/service-page/hitesh-kumar-counseling-psychologist?referral=service_list_widget",
    mobile: "7042010373",
  },
  {
    expertId: "expert65_jagrutishah",
    name: "Jagruti shah",
    position: "Counseling Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/service-page/jagruti-shah-counseling-psychologist",
    mobile: "9004675919",
  },
  {
    expertId: "expert66_shiwanikohli",
    name: "Shiwani Kohli",
    position: "Counseling Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/sessions",
    mobile: "9044429962",
  },
  {
    expertId: "expert75_rashmishah",
    name: "Rashmi Shah",
    position: "Counseling Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/service-page/rashmi-shah-counseling-psychologist",
    mobile: "9044429962",
  },
  {
    expertId: "expert88_keerthanapandian",
    name: "Keerthana Pandian",
    position: "Counseling Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/service-page/keerthana-p-counseling-psychologist",
    mobile: "9044429962",
  },
  {
    expertId: "expert89_Supritha",
    name: "Supritha",
    position: "Counseling Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/service-page/supritha-counseling-psychologist",
    mobile: "9044429962",
  },
  {
    expertId: "expert79_dowlathnisha",
    name: "Dowlath Nisha",
    position: "Counseling Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/service-page/dowlath-nisha-counseling-psychologist",
    mobile: "9044429962",
  },
  {
    expertId: "expert87_siddharthsharma",
    name: "Siddharth Sharma",
    position: "Counseling Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/service-page/siddharth-s-creative-art-therapist",
    mobile: "9044429962",
  },
  {
    expertId: "expert82_kazinafisa",
    name: "Kazi Nafisa Rahman",
    position: "Counseling Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/service-page/kazi-nafisa-counseling-psychologist",
    mobile: "9044429962",
  },
  {
    expertId: "expert84_fizapreetdhillon",
    name: "Fizapreet Dhillon",
    position: "Counseling Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/service-page/fizapreet-d-counseling-psychologist",
    mobile: "9044429962",
  },
  {
    expertId: "expert90_simranmalik",
    name: "Simran Malik",
    position: "Counseling Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/service-page/simran-malik-clinical-psychologist",
    mobile: "9044429962",
  },
  {
    expertId: "expert69_jankiverma",
    name: "Dr. Janki Verma",
    position: "Counseling Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/service-page/dr-janki-verma-counseling-psychologist",
    mobile: "9044429962",
  },
  {
    expertId: "expert77_pritikasangwan",
    name: "Pritika Sangwan",
    position: "Counseling Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/service-page/pritika-s-counseling-psychologist",
    mobile: "9044429962",
  },
  {
    expertId: "expert76_sriradhapodder",
    name: "Sriradha Podder",
    position: "Counseling Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/service-page/sriradha-p-counseling-psychologist",
    mobile: "9044429962",
  },
  {
    expertId: "expert80_anuveetkaur",
    name: "Anuveet Kaur",
    position: "Counseling Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/service-page/anuveet-kaur-counseling-psychologist",
    mobile: "9044429962",
  },
  {
    expertId: "expert72_pallabibose",
    name: "Pallabi Bose",
    position: "Counseling Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/service-page/pallabi-bose-counseling-psychologist",
    mobile: "9044429962",
  },
  {
    expertId: "expert92_drashtisenghani",
    name: "Drashti Senghani",
    position: "Counseling Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/service-page/drashti-s-counseling-psychologist",
    mobile: "9044429962",
  },
  {
    expertId: "expert71_harkiratkaur",
    name: "Harkirat Kaur",
    position: "Counseling Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/service-page/harkirat-kaur-counseling-psychologist",
    mobile: "9044429962",
  },
  {
    expertId: "expert74_srinidhiesh",
    name: "Srinidhi Eshwaroju",
    position: "Counseling Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/service-page/srinidhi-e-counseling-psychologist",
    mobile: "9044429962",
  },
  {
    expertId: "expert73_shwetatayal",
    name: "Shweta Tayal Goenka",
    position: "Counseling Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/service-page/shweta-tayal-counseling-psychologist",
    mobile: "9044429962",
  },
  {
    expertId: "expert67_ushaswapnil",
    name: "Usha Swapnil Gaonkar",
    position: "Counseling Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/service-page/usha-s-gaonkar-counseling-psychologist",
    mobile: "9044429962",
  },
  {
    expertId: "expert68_jayaiyer",
    name: "Jaya Iyer",
    position: "Counseling Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/service-page/jaya-iyer-counseling-psychologist",
    mobile: "9044429962",
  },
  {
    expertId: "expert78_anujasathe",
    name: "Anuja Sathe",
    position: "Counseling Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/service-page/anuja-sathe-counseling-psychologist-1",
    mobile: "9044429962",
  },
  {
    expertId: "expert91_sahersiddiqui",
    name: "Saher Siddiqui",
    position: "Counseling Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/service-page/saher-siddiqui-counseling-psychologist",
    mobile: "9044429962",
  },
  {
    expertId: "expert93_tejalikunte",
    name: "Tejali Kunte",
    position: "Creative Art Therapist",
    app_link: "",
    link: "https://www.manoshala.com/service-page/tejali-kunte-creative-art-therapist",
    mobile: "9044429962",
  },
  {
    expertId: "expert94_meenal",
    name: "Meenal",
    position: "Counseling Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/service-page/meenal-counseling-psychologist",
    mobile: "9044429962",
  },
  {
    expertId: "expert95_gowthamigarimalla",
    name: "Gowthami Garimalla",
    position: "Counseling Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/service-page/gowthami-g-counseling-psychologist",
    mobile: "9044429962",
  },
  {
    expertId: "expert96_vasundhrachoudhary",
    name: "Vasundhra Choudhary",
    position: "Clinical Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/service-page/vasundhra-c-clinical-psychologist",
    mobile: "9044429962",
  },
  {
    expertId: "expert97_vasundhrachoudhary",
    name: "Vasundhra Choudhary",
    position: "Yoga Expert",
    app_link: "",
    link: "https://www.manoshala.com/service-page/vasundhra-choudhary-yoga-expert",
    mobile: "9044429962",
  },
  {
    expertId: "expert98_zarinebharda",
    name: "Zarine Bharda",
    position: "Yoga Expert",
    app_link: "",
    link: "https://www.manoshala.com/service-page/zarine-bharda-yoga-expert",
    mobile: "9044429962",
  },
  {
    expertId: "expert99_charusukheja",
    name: "Charu Sukheja",
    position: "Yoga Expert",
    app_link: "",
    link: "https://www.manoshala.com/service-page/charu-sukheja-yoga-expert",
    mobile: "9044429962",
  },
  {
    expertId: "expert81_sumishreya",
    name: "Sumi Shreya",
    position: "Counseling Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/service-page/sumi-shreya-counseling-psychologist",
    mobile: "9044429962",
  },
  {
    expertId: "expert101_rohituttam",
    name: "Rohit Uttam Malve",
    position: "Counseling Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/service-page/rohit-uttam-counseling-psychologist",
    mobile: "9044429962",
  },
  {
    expertId: "expert102_mohdumar",
    name: "Mohd Umar Khan",
    position: "Counseling Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/service-page/mohd-umar-khan-counseling-psychologist",
    mobile: "9044429962",
  },
  {
    expertId: "expert100_anushreeg",
    name: "Anushree Gupta",
    position: "Counseling Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/service-page/anushree-gupta-counseling-psychologist",
    mobile: "9044429962",
  },
  {
    expertId: "expert103_simranmistry",
    name: "Simran Mistry",
    position: "Counseling Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/service-page/simran-mistry-counseling-psychologist",
    mobile: "9044429962",
  },
  {
    expertId: "expert105_kartikrai",
    name: "Kartik Rai",
    position: "Counseling Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/service-page/kartik-rai-counseling-psychologist",
    mobile: "9044429962",
  },
  {
    expertId: "expert106_nadiaabdul",
    name: "Nadia Abdul Raheem",
    position: "Counseling Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/service-page/nadia-raheem-counseling-psychologist",
    mobile: "9044429962",
  },
  {
    expertId: "expert107_himanshisharma",
    name: "Himanshi Sharma",
    position: "Counseling Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/service-page/himanshi-sharma-counseling-psychologist",
    mobile: "9044429962",
  },
  {
    expertId: "expert108_sanhatipanigrahi",
    name: "Sanhati Panigrahi",
    position: "Counseling Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/service-page/sanhati-p-clinical-psychologist",
    mobile: "9044429962",
  },
  {
    expertId: "expert109_pragatiAggarwal",
    name: "Pragati Aggarwal",
    position: "Counseling Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/service-page/pragati-a-counseling-psychologist",
    mobile: "9044429962",
  },
  {
    expertId: "expert110_meenakshibhardwaj",
    name: "Meenakshii Bhardwwaj",
    position: "Counseling Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/booking-calendar/meenakshii-b-counseling-psychologist?referral=service_list_widget",
    mobile: "9044429962",
  },
  {
    expertId: "expert111_drgeorge",
    name: "Dr. George Joseph V",
    position: "Counseling Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/sessions",
    mobile: "9044429962",
  },
  {
    expertId: "expert112_jaffrin",
    name: "Jaffrin",
    position: "Counseling Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/sessions",
    mobile: "9044429962",
  },
  {
    expertId: "expert113_nishi",
    name: "Nishi",
    position: "Counseling Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/sessions",
    mobile: "9044429962",
  },
  {
    expertId: "expert114_harshitaanand",
    name: "Harshita Anand",
    position: "Counseling Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/sessions",
    mobile: "9044429962",
  },
  {
    expertId: "expert115_sohinisarkar",
    name: "Sohini Sarkar",
    position: "Counseling Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/sessions",
    mobile: "9044429962",
  },
  {
    expertId: "expert116_suhrudhaa",
    name: "Suhrudhaa",
    position: "Counseling Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/sessions",
    mobile: "9044429962",
  },
  {
    expertId: "expert113_subiksha",
    name: "Subiksha Raman",
    position: "Counseling Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/service-page/subiksha-raman?referral=service_list_widget",
    mobile: "9044429962",
  },
  {
    expertId: "expert_rahul",
    name: "Rahul Verma",
    position: "Counseling Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/service-page/rahul-verma",
    mobile: "9044429962",
  },
  {
    expertId: "expert_simardang",
    name: "Simar Dang",
    position: "Clinical Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/service-page/simar-dang",
    mobile: "9044429962",
  },
  {
    expertId: "expert_sana",
    name: "Sana Panagar",
    position: "Counseling Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/service-page/sana-panagar",
    mobile: "9044429962",
  },
  {
    expertId: "expert_devashish",
    name: "Dr. Devashish",
    position: "Psychiatrist",
    app_link: "",
    link: "https://www.manoshala.com/service-page/dr-devashish-psychiatrist-1?referral=service_list_widget",
    mobile: "9044429962",
  },
  {
    expertId: "expert_kritivivek",
    name: "Kriti K Vivek",
    position: "Counseling Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/service-page/kriti-k-vivek-counseling-psychologist",
    mobile: "9044429962",
  },
  {
    expertId: "expert_hanumanhade",
    name: "Hanuman Hade",
    position: "Clinical Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/service-page/hanuman-hade",
    mobile: "9044429962",
  },
  {
    expertId: "expert_shreyaharan",
    name: "Shreya R Haran",
    position: "Counseling Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/service-page/shreya-r-haran",
    mobile: "9044429962",
  },
  {
    expertId: "expert_prekshaporwal",
    name: "Preksha Porwal",
    position: "Counseling Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/service-page/preksha-porwal-counseling-psychologist",
    mobile: "9044429962",
  },
  {
    expertId: "expert_niharikajoshi25",
    name: "Niharika Joshi",
    position: "Clinical Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/service-page/niharika-joshi-counseling-psychologist",
    mobile: "9044429962",
  },
  {
    expertId: "expert_nehammodi",
    name: "Neha M Mody",
    position: "Counseling Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/service-page/neha-m-mody-counseling-psychologist",
    mobile: "9044429962",
  },
  {
    expertId: "expert45_srimoyee",
    name: "Srimoyee",
    position: "Sr. Counseling Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/service-page/srimoyee-r-sr-counseling-psychologist",
    mobile: "9044429962",
  },
  {
    expertId: "expert_devashish",
    name: "Dr. Devashish",
    position: "Psychiatrist",
    app_link: "",
    link: "https://www.manoshala.com/service-page/dr-devashish-psychiatrist",
    mobile: "9044429962",
  },
  {
    expertId: "expert_alia",
    name: "Alia Vashishth",
    position: "Counseling Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/service-page/alia-vashishth-counseling-psychologist",
    mobile: "9044429962",
  },
  {
    expertId: "expert_kamakshi",
    name: "Kamakshi Gupte",
    position: "Counseling Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/service-page/kamakshi-gupte-counseling-psychologist",
    mobile: "9044429962",
  },
  {
    expertId: "expert_ananyas",
    name: "Ananya Srinivasa",
    position: "Clinical Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/service-page/ananya-s-clinical-psychologist",
    mobile: "9044429962",
  },
  {
    expertId: "expert_anushab",
    name: "Anusha Babbar",
    position: "Counseling Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/therapists-manoshala",
    mobile: "9044429962",
  },
  {
    expertId: "expert_drneeharika",
    name: "Dr Neeharika",
    position: "Psychiatrist",
    app_link: "",
    link: "https://www.manoshala.com/service-page/dr-neeharika-psychiatrist",
    mobile: "9044429962",
  },
  {
    expertId: "expert_chaitralee",
    name: "Chaitralee Deshpande",
    position: "Counseling Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/service-page/chaitralee-counseling-psychologist",
    mobile: "9044429962",
  },
  {
    expertId: "expert_nehammodi_couple",
    name: "Neha M Mody",
    position: "Counseling Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/service-page/neha-m-mody-couple-counselling-manoshala",
    mobile: "9044429962",
  },

  {
    expertId: "expert_alia_couple",
    name: "Alia Vashishth",
    position: "Counseling Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/service-page/alia-v-couple-counselling-manoshala",
    mobile: "9044429962",
  },
  {
    expertId: "expert_aditisolomon",
    name: "Aditi Solomon",
    position: "Counseling Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/service-page/aditisolomon-counseling-psychologist",
    mobile: "9044429962",
  },
  {
    expertId: "expert_ridhichadha",
    name: "Ridhi Chadha",
    position: "Counseling Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/service-page/ridhi-chadha-counseling-psychologist",
    mobile: "9044429962",
  },
  {
    expertId: "expert_vaishnavi",
    name: "Vaishnavi",
    position: "Counseling Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/service-page/vaishnavi-counseling-psychologist",
    mobile: "9044429962",
  },
  {
    expertId: "expert_kamaraj",
    name: "Kamaraj.M",
    position: "Counseling Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/service-page/kamaraj-m-counselling-psychology",
    mobile: "9044429962",
  },
  {
    expertId: "expert_tanvib",
    name: "Tanvi Bhardwaj",
    position: "Counseling Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/service-page/tanvi-bhardwaj-counseling-psychologist",
    mobile: "9044429962",
  },
  {
    expertId: "expert_deepikagupta",
    name: "Deepika Gupta",
    position: "Counseling Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/service-page/deepika-gupta-counselling-psychologist",
    mobile: "9044429962",
  },
  {
    expertId: "expert_seijal",
    name: "Seijal",
    position: "Counseling Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/service-page/seijal-counseling-psychologist",
    mobile: "9044429962",
  },
  {
    expertId: "expert_nishi",
    name: "Nishi",
    position: "Counseling Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/service-page/nishi-counseling-psychologist",
    mobile: "9044429962",
  },
  {
    expertId: "expert_manya",
    name: "Manya Kaushik",
    position: "Counseling Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/service-page/manya-kaushik-counseling-psychologist",
    mobile: "9044429962",
  },
  {
    expertId: "expert_mayuriu",
    name: "Dr. Mayuri Upmanyu",
    position: "Counseling Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/service-page/dr-mayuri-counseling-psychologist",
    mobile: "9044429962",
  },
  {
    expertId: "expert_yashna",
    name: "Yashna",
    position: "Counseling Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/service-page/yashna-counseling-psychologist",
    mobile: "9044429962",
  },
  {
    expertId: "expert_samriddhig",
    name: "Samriddhi Ghatak",
    position: "Counseling Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/service-page/samriddhi-counseling-psychologist",
    mobile: "9044429962",
  },
  {
    expertId: "expert_aryak",
    name: "Arya Kaushik",
    position: "Counseling Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/service-page/arya-kaushik-counseling-psychologist",
    mobile: "9044429962",
  },
  {
    expertId: "expert_tamrina",
    name: "Tamrina Matta",
    position: "Clinical Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/service-page/tamrina-matta-clinical-psychologist",
    mobile: "9044429962",
  },
  {
    expertId: "expert_parthg",
    name: "Parth Gandhi",
    position: "Counseling Psychologist",
    app_link: "",
    link: "https://www.manoshala.com/service-page/parth-gandhi-counseling-psychologist",
    mobile: "9044429962",
  },
  {
    expertId: "test_ayush",
    name: "Ayush Manoshala",
    position: "Clinical Psychologist",
    app_link: "https://www.google.co.in/",
    link: "https://www.manoshala.com/sessions",
    mobile: "9554840740",
  },
  {
    expertId: "test_amit",
    name: "Amit Manoshala",
    position: "Clinical Psychologist",
    app_link: "https://www.youtube.com/",
    link: "https://www.manoshala.com/sessions",
    mobile: "9554840740",
  },
];
